import React from 'react';
import Colors from 'enums/Colors';
import styled from 'styled-components';
import StyledGlobal from '../Alfabetizacao360NewDetail.styled';
import { RiShareBoxLine } from 'react-icons/ri';
import Img from '../assets/img_session_three.jpg';
import ImgRegua from '../assets/img_regua_vertical_nova.png';
import { IsCustomMaxWidth } from 'core/util/WindowSize';
import { useHistory } from 'react-router-dom';

const Styled = {
    Container: styled.div`
        display: flex;
        background-color: ${Colors.SoftBlue};
        color: ${Colors.White};
        height: 700px;

        @media screen and (max-width: 1200px) {
            flex-direction: column;
            height: auto;
        }
    `,

    Content: styled.div`
        width: 50%;


        @media screen and (max-width: 1200px) {
            width: 100%;
        }
    `,

    Title: styled.h1`
        font-family: 'Barlow';
        font-weight: 700;
        font-size: 32px;
        line-height: 150%;
        letter-spacing: -1%;
        vertical-align: middle;
        text-transform: uppercase;
        margin-bottom: 22px;
        max-width: 500px;
        margin-top: 22px;
    `,

    Tag: styled.h1`
        font-family: 'Barlow';
        font-weight: 400;
        font-size: 16px;
        line-height: 150%;
        letter-spacing: -1%;
        vertical-align: middle;
    `,

    DescriptionPart1: styled.p`
        font-family: 'Barlow';
        font-weight: 400;
        font-size: 16px;
        line-height: 150%;
        letter-spacing: -1%;
        vertical-align: middle;
    `,
    DescriptionPart2: styled.p`
        font-family: 'Barlow';
        font-weight: 700;
        font-size: 20px;
        line-height: 150%;
        letter-spacing: -1%;
        vertical-align: middle;
    `,
};

const ThreeSession = () => {
    const history = useHistory();
    const isMax1600 = IsCustomMaxWidth(1600);
    const isMax1100 = IsCustomMaxWidth(1100);
    const isMax500 = IsCustomMaxWidth(500);

    const goToLink = () => {
        history.push(`/playlist-videos/promover_alfabetizacao/ywCIoO897SQ`);
        window.location.reload();
    };

    return (
        <Styled.Container>
            <Styled.Content
                style={{
                    paddingLeft: isMax500 ? '20px' : isMax1600 ? '80px' : '280px',
                    paddingBottom: isMax1100 ? '40px' : '80px',
                    paddingTop: '60px'
                }}
            >
                <Styled.Tag
                    style={{ maxWidth: '520px' }}
                    dangerouslySetInnerHTML={{
                        __html: `
                    *Ministério da Cultura, Alura Start e Guaraná Antarctica apresentam: ALFABETIZAÇÃO INTEGRAL EM APOIO AO COMPROMISSO NACIONAL CRIANÇA ALFABETIZADA
                    
                    `,
                    }}
                />

                <Styled.Title>UM CURSO PARA PROMOVER A ALFABETIZAÇÃO</Styled.Title>
                <Styled.DescriptionPart1
                    style={{ maxWidth: '520px', marginBottom: '20px' }}
                    dangerouslySetInnerHTML={{
                        __html: `
              Em 2024 a Cátedra Instituto Ayrton Senna de Inovação em Avaliação Educacional  ofertou o curso Alfabetização Integral. O cursos foi pensado para apoiar a alfabetização das crianças brasileiras e contou com grandes nomes do cenário da educação, como Maria Helena Guimarães e Castro, Inês Miskalo, Roxane Rojo e Kátia Smole, entre outros. 

                    
                    `,
                    }}
                />
                <Styled.DescriptionPart2
                    style={{ maxWidth: '520px', marginBottom: '40px' }}
                    dangerouslySetInnerHTML={{
                        __html: `
             Agora você tem a oportunidade de acessar os <span style="color: #FFCA00">vídeos com os 10 temas fundamentais</span> que foram trabalhados no curso.

                    
                    `,
                    }}
                />
                <StyledGlobal.ButtonYellow onClick={goToLink}>
                    Acessar <RiShareBoxLine />
                </StyledGlobal.ButtonYellow>
            </Styled.Content>
            <Styled.Content style={{ display: 'flex', flexDirection: 'column' }}>
                <img style={{ width: '100%', height: '60%', objectFit: 'cover' }} src={Img} alt="" />
                <img style={{ backgroundColor: Colors.White, height: '40%', objectFit: "contain"  }} src={ImgRegua} alt="" />
            </Styled.Content>
        </Styled.Container>
    );
};

export default ThreeSession;
